module.exports = __webpack_public_path__ + "static/media/Mulish-Bold.bb1bbe4e.woff2";